import { Component, OnInit } from '@angular/core';
import {
	AbstractControl,
	FormControl,
	FormGroup,
	Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { User } from 'src/app/shared/models/security/user';
import { PasswordMatchValidator } from 'src/app/shared/utils/password-match-validator';

@Component({
	selector: 'app-confirm-account',
	templateUrl: './confirm-account.component.html',
	styleUrls: ['./confirm-account.component.scss']
})
export class ConfirmAccountComponent implements OnInit {
	constructor(
		private passwordMatchValidator: PasswordMatchValidator,
		private route: ActivatedRoute,
		private facade: FacadeService,
		private logger: LogService,
		private router: Router
	) {}

	successfulChange = false;
	unsuccessfulChange = false;
	changePasswordForm = new FormGroup(
		{
			newPassword: new FormControl('', [
				Validators.required,
				Validators.minLength(8),
				Validators.pattern(
					`^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$`
				)
			]),
			newPasswordRepeated: new FormControl('', [
				Validators.required,
				Validators.minLength(8),
				Validators.pattern(
					`^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$`
				)
			])
		},
		{ validators: this.passwordMatchValidator.validate }
	);

	isConfirmed = false;
	token: string;

	ngOnInit(): void {
		this.token = this.route.snapshot.paramMap.get('token');
		console.log(this.token);
		this.facade.authenticationService.confirmAccount(this.token).subscribe({
			next: (isConfirmed: boolean) => (this.isConfirmed = isConfirmed),
			error: (err) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.logger.log(
					'' + err.status + ' ' + err.error.message ? err.error.message : ''
				);
			}
		});
	}

	// Helper method to determince the form has any errors
	isFormError() {
		const { errors } = this.changePasswordForm;
		const passwordTouched = this.changePasswordForm.get('newPassword').touched;
		const confirmPasswordTouched = this.changePasswordForm.get(
			'newPasswordRepeated'
		).touched;
		return errors && passwordTouched && confirmPasswordTouched;
	}

	changePassword(): void {
		this.facade.authenticationService
			.setPasswordConfirmationAccount(
				this.token,
				this.changePasswordForm.get('newPassword').value
			)
			.subscribe({
				next: (succ) => {
					this.successfulChange = true;
					this.clearStorage();
					this.router.navigate(['/login']);
				},
				error: (err) => {
					this.unsuccessfulChange = true;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.log(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	closeAlerts(): void {
		this.successfulChange = false;
		this.unsuccessfulChange = false;
	}

	clearStorage() {
		this.facade.dataStorageService.clearStorage();
	}

	convertToFormControl(absCtrl: AbstractControl | null): FormControl {
		const ctrl = absCtrl as FormControl;
		return ctrl;
	}
}
